import {
    URLAPI,
    LOG_MILEAGE_VEHICLE_CREATE_PATH,
    LOG_MILEAGE_VEHICLE_UPDATE_PATH,
    LOG_MILEAGE_VEHICLE_LIST_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _create_log_mileage_vehicle: {
        data: {},
        status: 0,
        message: {},
    },
    _update_log_mileage_vehicle: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_LOG_MILEAGE_VEHICLE = "CREATE_LOG_MILEAGE_VEHICLE";
export const UPDATE_LOG_MILEAGE_VEHICLE = "UPDATE_LOG_MILEAGE_VEHICLE";

export const log_mileage_vehicle_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_LOG_MILEAGE_VEHICLE:
            return {
                ...state,
                _create_log_mileage_vehicle: action.payload,
            };
        case UPDATE_LOG_MILEAGE_VEHICLE:
            return {
                ...state,
                _update_log_mileage_vehicle: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getMileageVehicle = async (token, paramsUrl) => {
    return await axios.get(`${URLAPI}${LOG_MILEAGE_VEHICLE_LIST_PATH}${paramsUrl}`, {
        headers: {
            Authorization: `Token ${token}`,
        },
    });
};


export const createLogMileageVehicle = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${LOG_MILEAGE_VEHICLE_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_LOG_MILEAGE_VEHICLE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_LOG_MILEAGE_VEHICLE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_LOG_MILEAGE_VEHICLE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateLogMileageVehicle = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${LOG_MILEAGE_VEHICLE_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_LOG_MILEAGE_VEHICLE,
            payload: {
                data: response.data,
                status: response.status,
                message: response.data.mensaje,
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_LOG_MILEAGE_VEHICLE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_LOG_MILEAGE_VEHICLE,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error en el servidor",
                },
            });
        }
    }
};

export const clear_log_mileage_vehicle = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
